'use client'

import { useTranslation } from '@/i18n/client'

export const I18nWarmer = ({ lang }: { lang: string }) => {
  useTranslation(lang)

  return null
}
